export const DEFAULT_MAX_SIZE_MB = 100;

export const fileAcceptTypes = {
  CSV: { 'text/csv': ['.csv'] },
  XLSX: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
  Image: { 'image/*': ['.png', '.jpeg', '.jpg'] },
  JSON: { 'application/json': ['.json'] },
};
